<template>
    <div>
        <topnav
            @tosearch="tosearch"
            :keywords="keyword"
            :toptype="toptype"
            :isSearch="path"
            types="4"
        ></topnav>
        <div class="" style="min-height: 600px">
            <div class="" v-if="config">
                <el-image
                    class="topimg"
                    :src="config.zlfw_pic | addurl"
                    fit="fill"
                ></el-image>
            </div>
            <div v-if="lease_list.length" class="response bggray">
                <div class="marginauto comswidth">
                    <div class="flex justify-between align-center flex-wrap">
                        <div
                            v-for="(item, index) in lease_list"
                            @click="todetail(item.id)"
                            :key="index"
                            class="slideInLeft animated pointer"
                        >
                            <div class="hvr-float lone">
                                <div class="line"></div>
                                <div
                                    class="
                                        lcon
                                        flex
                                        justify-between
                                        align-center
                                    "
                                >
                                    <div
                                        class="flex-sub"
                                        style="min-height: 161px"
                                    >
                                        <div
                                            class="text-cut text-center"
                                            style="width: 100%; font-size: 24px"
                                        >
                                            {{ item.title ? item.title : "" }}
                                        </div>
                                        <div
                                            class="
                                                flex
                                                justify-between
                                                align-center
                                            "
                                            style="padding-top: 20px"
                                        >
                                            <div
                                                class="text-center text-cut"
                                                style="width: 25%"
                                            >
                                                <div
                                                    class=""
                                                    style="
                                                        color: #ffa10e;
                                                        font-size: 31px;
                                                        font-weight: 600;
                                                    "
                                                >
                                                    {{ item.number }}
                                                </div>
                                                <div class="">房间号</div>
                                            </div>
                                            <div
                                                class="text-center text-cut"
                                                style="width: 25%"
                                            >
                                                <div
                                                    class=""
                                                    style="
                                                        color: #ffa10e;
                                                        font-size: 31px;
                                                        font-weight: 600;
                                                    "
                                                >
                                                    {{ item.position
                                                    }}<span
                                                        style="
                                                            font-size: 22px;
                                                            font-weight: 500;
                                                        "
                                                        >楼</span
                                                    >
                                                </div>
                                                <div class="">位置</div>
                                            </div>
                                            <div
                                                class="text-center text-cut"
                                                style="width: 25%"
                                            >
                                                <div
                                                    class=""
                                                    style="
                                                        color: #ffa10e;
                                                        font-size: 31px;
                                                        font-weight: 600;
                                                    "
                                                >
                                                    {{ item.work }}
                                                </div>
                                                <div class="">工位数</div>
                                            </div>
                                            <div
                                                class="text-center text-cut"
                                                style="width: 25%"
                                            >
                                                <div
                                                    class=""
                                                    style="
                                                        color: #ffa10e;
                                                        font-size: 31px;
                                                        font-weight: 600;
                                                    "
                                                >
                                                    {{ item.area
                                                    }}<span
                                                        style="
                                                            font-size: 22px;
                                                            font-weight: 500;
                                                        "
                                                        >㎡</span
                                                    >
                                                </div>
                                                <div class="">面积</div>
                                            </div>
                                        </div>
                                        <div
                                            class="response flex justify-center"
                                        >
                                            <div
                                                @click.stop="shownow(item.id)"
                                                class="nowbtn pointer"
                                            >
                                                立即咨询
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="detailcss"
                                        style="position: relative"
                                    >
                                        <el-image
                                            style="
                                                width: 226px;
                                                height: 161px;
                                                display: block;
                                            "
                                            :src="item.image | addurl"
                                            fit="fill"
                                        ></el-image>
                                        <div class="detailall">查看详情</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center response">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div class="" v-if="!lease_list.length && !load">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        <el-dialog title="咨询" :visible.sync="addcompany">
            <div class="" style="text-align: center; margin: 0 auto">
                <el-form :model="cominfo" style="text-align: center">
                    <el-form-item label="姓名：" :label-width="formLabelWidth">
                        <el-input
                            style="max-width: 420px; flex: 1"
                            placeholder="请输入"
                            v-model="cominfo.name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="电话：" :label-width="formLabelWidth">
                        <el-input
                            style="max-width: 420px; flex: 1"
                            placeholder="请输入"
                            v-model="cominfo.phone"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="咨询内容："
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            type="textarea"
                            :rows="2"
                            style="max-width: 420px; flex: 1"
                            placeholder="请输入咨询内容"
                            v-model="cominfo.content"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系电话："
                        :label-width="formLabelWidth"
                        style="font-size: 18px"
                    >
                        <div class="flex align-center">
                            <div
                                style="
                                    flex: 1;
                                    max-width: 420px;
                                    font-size: 18px;
                                    text-align: left;
                                    margin: auto;
                                "
                            >
                                {{ config.phone }}
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-center align-center">
                <el-button
                    @click="tosub"
                    :disabled="nowdisabled"
                    type="primary"
                >
                    提 交
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            toptype: 7,
            pagesize: 10,
            totalnum: 0,
            currentPage: 1,
            pagerCount: 7,
            formLabelWidth: "120px",
            cominfo: {
                question_id: "",
                type: 3,
                company_name: "",
                name: "",
                phone: "",
                content: "",
                user_id: "",
            },
            lease_list: [],
            addcompany: false,
            config: "",
            keyword: "",
            path: "/tenancy",
            nowdisabled: false,
            load: true,
        };
    },
    computed: {
        ...mapGetters(["token", "config"]),
    },
    methods: {
        todetail(id) {
            this.$router.push({ path: "/tenancydetail", query: { id: id } });
        },
        shownow(id) {
            if (!this.token) {
                this.$message.error("请登录");
                return false;
            }
            this.addcompany = true;
            this.cominfo.question_id = id;
        },
        tosub() {
            // question_add
            if (
                !this.cominfo.content ||
                !this.cominfo.phone ||
                !this.cominfo.name
            ) {
                this.$message({
                    message: "请完善信息",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!this.cominfo.phone) {
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(this.cominfo.phone)) {
                this.$message({
                    message: "手机号码错误！",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            this.cominfo.user_id = this.token;
            this.nowdisabled = true;
            this.$api.index
                .question_add(this.cominfo)
                .then((response) => {
                    console.log(response);
                    this.$message({
                        message: response.msg,
                        type: "none",
                        duration: 1000,
                    });
                    this.addcompany = false;
                    this.cominfo.phone = "";
                    this.cominfo.name = "";
                    this.cominfo.content = "";
                    this.nowdisabled = false;
                })
                .catch(() => {
                    this.nowdisabled = false;
                });
        },
        handleSizeChange() {},
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getlease_list();
        },
        getlease_list() {
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                keyword: this.keyword,
            };
            this.$api.index.lease_list(data).then((response) => {
                console.log("lease_listlease_list", response);
                this.lease_list = response.data;
                this.totalnum = response.count;
            });
        },
        tosearch(data) {
            console.log(data);
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlease_list();
        },
    },
    created() {
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlease_list();
        } else {
            this.getlease_list();
        }
        this.config = JSON.parse(localStorage.getItem("config"));
    },
};
</script>
<style scoped>
.comswidth {
    width: 1320px;
    padding: 30px 0;
}
.topimg {
    width: 100%;
    height: 500px;
    display: block;
}
.bggray {
    background-color: #eef1fa;
}
.lone {
    width: 652px;
    min-height: 200px;
    background-color: #ffffff;
    border-radius: 10px;
    position: relative;
    margin-bottom: 35px;
}
.line {
    width: 3px;
    min-height: 230px;
    background-color: #0065ee;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 0;
}
.lcon {
    margin: 20px 20px 20px 10px;
}
.nowbtn {
    width: 287px;
    height: 42px;
    line-height: 42px;
    background-color: #0e6cec;
    border-radius: 4px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    margin-top: 35px;
}
.detailcss:hover .detailall {
    display: block;
}
.detailall {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    /* background: rgba(0,101,238,0.5); */
    text-align: center;
    line-height: 161px;
    display: none;
}
</style>


// WEBPACK FOOTER //
// tenancy.vue?06a84375